// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"756":"ce46d809","807":"23c8f09e","893":"a97b5909"}[chunkId] + ".js";
};